angular
    .module('empower.control')
    .directive("bsbSearch", ['$rootScope', 'bsbService', 'popupService',
        function ($rootScope, bsbService, popupService) {
            return {
                restrict: 'E',
                templateUrl: 'module/control/bsbSearch/bsb-search.html',
                scope: {
                    bsbNumber: '=',
                    isRequired: '=',
                },
                controller: function ($scope) {
                    $scope.bsbNumber = null;
                    $scope.placeholder = "Search for BSB Number";
                    $scope.rowsPerPage = 50;

                    $scope.fnQuery = function (childScope, key, callback) {
                        bsbService.searchBSB(1, $scope.rowsPerPage, key).then(function (data) {
                            var list = data.Data.map(function (x) {
                                return {
                                    id: x.BSBNumber,
                                    text: x.BSBNumber + ' - ' + x.Bank + ' - ' + x.Branch
                                };
                            });

                            if (data.Data.length > 0) {
                                list.unshift({
                                    id: 'null',
                                    text: $scope.placeholder
                                });
                            }

                            var result = {
                                results: list,
                                totalItems: data.RowsCount
                            };                          

                            childScope.currentList = list;
                            childScope.totalItemsFound = result.RowsCount;
                            childScope.totalItemsShown = result.RowsCount > $scope.rowsPerPage ? $scope.rowsPerPage : result.RowsCount;
                            childScope.cacheDataSource[key] = result;
                            callback(result);
                        });
                    }; // fnQuery

                    $scope.fnCurrent = function (childScope, callback) {
                        if (childScope.ngModel !== null && childScope.ngModel !== undefined) {
                            //only get policy info when another policy is selected
                            if (!childScope.selectedData || childScope.selectedData.id !== childScope.ngModel) {
                                // check if selected policy is in current list policy
                                var bsbInfo = childScope.currentList.filter(function (p) {
                                    return p.id == childScope.ngModel;
                                })[0];

                                if (bsbInfo) {
                                    childScope.selectedData = {
                                        id: bsbInfo.id,
                                        text: bsbInfo.text                                     
                                    };
                                    callback([childScope.selectedData]);

                                } else {    
                                    bsbService.BSBByNumber(childScope.ngModel).then(function (data) {
                                        childScope.selectedData = {
                                            id: data.BSBNumber,
                                            text:  data.BSBNumber + ' - ' + data.Bank + ' - ' + data.Branch
                                        };
                                        callback([childScope.selectedData]);
                                    });                                
                                }
                            } else {
                                callback([childScope.selectedData]);
                            }

                        } else {
                            callback([{
                                id: 'null',
                                text: $scope.placeholder
                            }]);
                        }
                    }; // fnCurrent                   
                  
                }, // controller
                link: function (scope, element, attrs) {
                } // link
            };
        }
    ])
